import React, { Component } from 'react';
import "../index.css";

export default class Prosjekterkomponent extends Component {
  render() {
    return (
      <div>
        
        HEi
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Prosjekterkomponent.js